const feedbackStatusEnum = {
  CREATE: 1,
  RECEIVED: 2,
  DONE: 3,
  CANCELED: 4,
  IN_PROGRESS: 5,
  // IN_PROGRESS_WAITING_PROGRESS: 6,
  IN_PROGRESS_DOING: 6,
  IN_PROGRESS_DONE: 7,
  IN_PROGRESS_CANCEL: 8
}
export default feedbackStatusEnum


// WEBPACK FOOTER //
// ./src/enum/feedbackStatusEnum.js